import React, { FC } from 'react';
import { ForgotPasswordView } from '../components';

export const ForgotPasswordPage: FC = () => {
  return <ForgotPasswordView />;
};
